import anime from 'animejs/lib/anime.es.js';
import Swiper, { Autoplay, EffectFade, Pagination } from 'swiper';
// import 'swiper/css';
// import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
// import 'swiper/css/pagination';

export default class {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.swiper');
    this.dom.slide = this.dom.slider.querySelectorAll('.swiper-slide');
    this.dom.circle = null;

    this.length = this.dom.slide.length;

    this.slider = null;
    this.option = {
      modules: [Autoplay, EffectFade, Pagination],
      init: false,
      loop: true,
      speed: 900,
      slidesPerView: 375 / (315 + 22),
      centeredSlides: true,
      pauseOnMouseEnter: false,
      noSwiping: false,
      pagination: {
        el: this.dom.el.querySelector('.swiper-pagination'),
        type: 'bullets',
        renderBullet: (index, className) => {
          //中に数字を表示
          return '<span class="' + className + '"><svg width="30" height="30"><circle cx="15" cy="15" r="14.5" data-js="swpr-bullet" /></svg>' + '0' + (index + 1) + '</span>';
        }
      },
      breakpoints: {
        // when window width is >= 768px
        768: {
          slidesPerView: 1227 / (519 + 50),
          centeredSlides: false,
        }
      }
    };

    this.init();
  }

  init() {
    const _this = this;
    this.slider = new Swiper(this.dom.slider, this.option);
    this.slider.init();
    this.dom.circle = this.dom.el.querySelectorAll('[data-js="swpr-bullet"]');

    this.circleSizeSet();
    this.autoplay();

    // スワイプ時にアニメーションをリセット
    this.slider.on('slideChange', () => {
      this.resetAnimation();
      this.autoplay();
    });

    window.addEventListener('resize', ()=>{
      _this.circleSizeSet();
    });
  }

  autoplay() {
    const _this = this;
    this.dom.bullet = this.dom.el.querySelectorAll('[data-js="swpr-bullet"]');
    const active = _this.dom.el.querySelector('.swiper-pagination-bullet-active [data-js="swpr-bullet"]');

    let tl = anime.timeline({
      easing: 'linear',
    });
    
    // Add children
    tl
    .add({
      targets: active,
      strokeDashoffset: [anime.setDashoffset, 0],
      direction: 'alternate',
      duration: 4800,
      changeComplete: function(anim) {
        const nextIndex = (_this.slider.realIndex + 1) % _this.slider.slides.length;
        // _this.slider.slideToLoop(nextIndex);
        _this.slider.slideNext();
        _this.autoplay();
      }
    })
    .add({
      targets: active,
      strokeDashoffset: [0, -91],
      duration: 900,
      easing: 'cubicBezier(.5, .05, .1, .3)',
    });
  }

  circleSizeSet() {
    let root = document.documentElement; // htmlのルート要素を取得
    let style = window.getComputedStyle(root).getPropertyValue('font-size'); // ルート要素のcssプロパティを全て取得し、その中からフォントサイズを取得
    let stFontSize = parseFloat(style); // float型の数値に変換

    if (1366 <= window.innerWidth) {
      this.setSize = stFontSize * (39 / 16) * .5;
    }
    else if (1200 <= window.innerWidth) {
      this.setSize = stFontSize * (37.47 / 15.375) * .5;
    }
    else if (768 <= window.innerWidth) {
      // このタイミングはフォントサイズがvw指定なので、計算式が違うので注意
      const fs = window.innerWidth * .01166;
      this.setSize = (2.437 * fs) * .5;
    }
    else {
      this.setSize = stFontSize * (30 / 16) * .5;
    }

    [...this.dom.circle].forEach(elm=>{
      elm.setAttribute('cx', this.setSize);
      elm.setAttribute('cy', this.setSize);
      elm.setAttribute('r', this.setSize - .5);

      elm.parentElement.setAttribute('width', this.setSize * 2);
      elm.parentElement.setAttribute('height', this.setSize * 2);

      // this.circleLength = Math.ceil(elm.getTotalLength()); // IE11が未対応
      this.circleLength = ( this.setSize - .5 ) * 2 * Math.PI;
      root.style.setProperty('--circle-length', this.circleLength);
    });
  }

  resetAnimation() {
    const _this = this;
  
    // すべてのアニメーションを停止
    anime.remove(this.dom.circle);
  
    // アクティブなバレットを取得
    const active = _this.dom.el.querySelector('.swiper-pagination-bullet-active [data-js="swpr-bullet"]');
  
    // サークルのアニメーションをリセット
    if (active) {
      anime.set(active, {
        strokeDashoffset: anime.setDashoffset(active),
      });
    }
  }

  destroy() {
    this.slider.destroy(true, true);
  }
}
